module.exports = __webpack_public_path__ + "static/media/MD_AZ_header.7bc71e91.jpg";